import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { formatPrice } from '~/utils/format';

interface IOrder {
  total: string;
  service_fee: string;
  processing_fee: string;
}

interface ISold {
  eventId: number;
}

const Sold: React.FC<ISold> = ({ eventId }) => {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    api.get<IOrder[]>(`orders/events/${eventId}`).then(async (response) => {
      const purchases = response.data.reduce((previous, current) => {
        return (
          previous +
          (parseFloat(current.total) -
            parseFloat(current.service_fee) -
            parseFloat(current.processing_fee))
        );
      }, 0);

      setTotal(purchases);
    });
  }, [eventId]);

  return <>{formatPrice(total)}</>;
};

export default Sold;
